import fpApiUtil from "./fp-api-util";

const ANALYSIS = "factoryplan/analysis";

// 자재 소요계획(PSI, 공장>품목별 기초재고/입고예정/필요수량/만료수량/기말재고 크로스탭) — 크로스탭 그리드용.
// AnalysisController#getMrpPsis(백엔드는 factoryplan/analysis/mrp/psi). 다른 크로스탭 화면과 같은
// { crosstabHeader, chartHeader, data[].pivotData } 형태, measure(analysisIndicator)가 leaf 필드.
const getMaterialPsis = (params) => fpApiUtil.postParams(`${ANALYSIS}/mrp/psi`, params);

// 같은 엔드포인트의 차트용 호출 — 그리드에서 클릭한 행(plantCd/itemCd)으로 드릴다운, useGrouping:true로
// 그 레벨까지 백엔드가 집계해서 내려준다(MaterialPsiCrossTabDto.merge, GroupingLevel 참고).
// 컬럼 필터(changes)는 1차 미이관이라 항상 빈 객체로 보낸다(fp-report-screen-guide.md §A-6e와 동일 결정).
const getMaterialPsiChart = (params, changes) => fpApiUtil.postFields(`${ANALYSIS}/mrp/psi`, { params, changes });

const fpMaterialPsiService = { getMaterialPsis, getMaterialPsiChart };
export default fpMaterialPsiService;
